const SUPPORT_WIDGET_URL_PARAMS = ['support', 'contact_support'];
const SUPPORT_WIDGET_OPEN_PARAM_VALUES = new Set(['', '1', 'true']);
const MINTLIFY_THREAD_ID_PARAM = 'threadId';
const MINTLIFY_THREAD_ID_PATTERN = /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i;
export function shouldOpenSupportWidgetFromParams(searchParams) {
    if (!searchParams)
        return false;
    return SUPPORT_WIDGET_URL_PARAMS.some((param) => {
        const value = searchParams.get(param);
        return value !== null && SUPPORT_WIDGET_OPEN_PARAM_VALUES.has(value.toLowerCase());
    });
}
export function getMintlifyThreadIdFromParams(searchParams) {
    const threadId = searchParams?.get(MINTLIFY_THREAD_ID_PARAM)?.trim();
    return threadId && MINTLIFY_THREAD_ID_PATTERN.test(threadId) ? threadId.toUpperCase() : undefined;
}
//# sourceMappingURL=shouldOpenSupportWidgetFromParams.js.map